<template>
  <b-modal
    :visible.sync="visible"
    no-close-on-backdrop
    title="Cliente"
    @hide="closeModal"
    size="lg"
    hide-footer
  >
    <b-card v-if="!!option" id="page-customer-form" no-body class="mb-0">
      <b-card-header>
        <b-card-body class="p-0">
          <validation-observer ref="simpleRules">
            <b-form>
              <b-row>
                <b-col cols="12" sm="12" md="6">
                  <b-form-group :label="$t(label('name'))" label-for="name">
                    <validation-provider
                      #default="{ errors }"
                      :name="$t(label('name'))"
                      rules="required"
                    >
                      <b-form-input
                        id="name"
                        v-model="customers.name"
                        :state="errors.length > 0 ? false : null"
                        :placeholder="$t(label('name'))"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="12" md="6">
                  <b-form-group
                    :label="$t(label('last_name'))"
                    label-for="lastName"
                  >
                    <validation-provider
                      #default="{ errors }"
                      :name="$t(label('last_name'))"
                      rules="required"
                    >
                      <b-form-input
                        id="lastName"
                        v-model="customers.lastName"
                        :state="errors.length > 0 ? false : null"
                        :placeholder="$t(label('last_name'))"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="12" md="6">
                  <b-form-group :label="$t(label('dni'))" label-for="dni">
                    <validation-provider
                      #default="{ errors }"
                      :name="$t(label('dni'))"
                      rules="required"
                    >
                      <b-form-input
                        id="dni"
                        v-model="customers.dni"
                        :state="errors.length > 0 ? false : null"
                        :placeholder="$t(label('dni'))"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="12" md="6">
                  <b-form-group
                    :label="$t(label('email'))"
                    label-for="email"
                    rules="required|email"
                  >
                    <validation-provider
                      #default="{ errors }"
                      :name="$t(label('email'))"
                      rules="required|email"
                    >
                      <b-form-input
                        id="email"
                        v-model="customers.email"
                        type="email"
                        :state="errors.length > 0 ? false : null"
                        :placeholder="$t(label('email'))"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="12" md="6">
                  <b-form-group :label="$t(label('phone'))" label-for="phone">
                    <vue-tel-input
                      inputId="phoneNumber"
                      name="phoneNumber"
                      v-model="customers.phoneNumber"
                      :mode="'international'"
                      defaultCountry="ve"
                      :disabledFetchingCountry="true"
                      :inputOptions="inputTelOption"
                      @open="onDropdownOpen(true)"
                      @close="onDropdownOpen(false)"
                    >
                      <template v-slot:arrow-icon>
                        <span>{{ openTelInput ? "▲" : "▼" }}</span>
                      </template>
                    </vue-tel-input>
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="12" md="6">
                  <b-form-group
                    :label="$t(label('address'))"
                    label-for="address"
                  >
                    <b-form-input
                      id="address"
                      v-model="customers.address"
                      :placeholder="$t(label('address'))"
                    />
                  </b-form-group>
                </b-col>

                <b-col
                  class="d-flex justify-content-end align-items-center"
                  cols="12"
                >
                  <b-button
                    type="submit"
                    variant="primary"
                    class="mr-1"
                    :disabled="!isSave"
                    @click.prevent="onSubmit"
                  >
                    {{ $t("save") }}
                  </b-button>
                  <b-button
                    type="reset"
                    variant="outline-secondary"
                    @click="onCancel"
                  >
                    {{ $t("cancel") }}
                  </b-button>
                </b-col>
              </b-row>
            </b-form>
          </validation-observer>
        </b-card-body>
      </b-card-header>
    </b-card>
  </b-modal>
</template>

<script>
import _ from "lodash";
import { required, email, min } from "@validations";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import {
  BButton,
  BFormGroup,
  BFormSelect,
  BFormInput,
  BForm,
  BFormTextarea,
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BRow,
  BCol,
  BFormInvalidFeedback,
  BFormDatepicker,
  BFormTimepicker,
  BFormCheckbox,
  BListGroup,
  BCollapse,
  BListGroupItem,
  BBadge,
} from "bootstrap-vue";
import vSelect from "vue-select";
import { VueTelInput } from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";

import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { getParams, showLoading, stopLoading } from "@core/utils/utils";

const customers = {
  idClient: null,
  guidCompany: null,
  name: "",
  lastName: "",
  dni: "",
  phoneNumber: "",
  email: "",
  address: "",
};

export default {
  components: {
    BButton,
    BFormGroup,
    BFormSelect,
    BFormInput,
    BForm,
    BFormTextarea,
    ValidationProvider,
    ValidationObserver,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BRow,
    BCol,
    vSelect,
    BFormInvalidFeedback,
    BFormDatepicker,
    BFormTimepicker,
    VueTelInput,
    BFormCheckbox,
    BListGroup,
    BCollapse,
    BListGroupItem,
    BBadge,
  },
  name: "EventModal",
  props: ["visible", "options"],
  data() {
    return {
      isSave: true,
      customers: Object.assign(customers),
      eventCopy: { ...this.event },
      option: "",
      required,
      email,
      openTelInput: false,
      inputTelOption: {
        placeholder: "Ingrese un número de teléfono",
      },
      isSaveMode: false,
    };
  },
  watch: {
    event: {
      immediate: true,
      handler(val) {
        // this.appointment = Object.assign(this.appointment, {
        //   idAppointment: val.idAppointment,
        //   guidService: val.guidService,
        //   appointmentDate: val.appointmentDate,
        //   durationMinutes: val.durationMinutes,
        //   clients: val.clients,
        //   idEmployee: val.idEmployee,
        //   idCatStatus: val.catStatus,
        //   contactDetails: val.contactDetails,
        //   notes: val.notes,
        //   isRecurring: val.isRecurring,
        //   idCatRecurrencePattern: val.idCatRecurrencePattern,
        //   endDateTime: val.endDateTime,
        //   employee: val.employee,
        //   appointmentTimeStar: val.appointmentTimeStar,
        //   appointmentTimeEnd: val.appointmentTimeEnd,
        //   payments: [],
        //   seviceAppoimnet: val.seviceAppoimnet,
        //   statusHistory: val.statusHistory || [],
        // });
      },
    },
    options: {
      immediate: true,
      handler(val) {
        this.isSave = true;
        this.option = val;
      },
    },
  },

  async created() {
    localize("es");
  },

  methods: {
    onSubmit() {
      this.$refs.simpleRules.validate().then((success) => {
        if (success) {
          this.isSave = false;
          // console.log(this.customers);
          this.$emit("save", this.customers);
          this.onCancel();
        }
      });
    },

    closeModal() {
      this.isSave = true;
      this.$emit("close");
      this.onCancel();
    },

    onDropdownOpen(isOpen) {
      this.openTelInput = isOpen;
    },

    getTitle() {
      if (this.option === 1) return "register";
      else if (this.option === 2) return "show";
      else if (this.option === 3) return "edit";
    },

    label(field) {
      return `pages.customers.form.label.${field}`;
    },

    toggleHistoryCollapse() {
      this.isHistoryCollapsed = !this.isHistoryCollapsed;
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString("es-ES", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },

    label(field) {
      return `pages.customers.form.label.${field}`;
    },

    getTitle() {
      if (this.option === 1) return "register";
      else if (this.option === 2) return "show";
      else if (this.option === 3) return "edit";
    },

    goBack() {
      this.$refs.simpleRules.reset();
      router.back();
      this.onCancel();
    },

    onCancel() {
      this.$refs.simpleRules.reset();
      this.customers = Object.assign({
        idClient: null,
        guidCompany: null,
        name: "",
        lastName: "",
        dni: "",
        phoneNumber: "",
        email: "",
        address: "",
      });
    },

    alertToast(type = null, title = null, message = null, icon) {
      this.$bvToast.toast(message, {
        title,
        variant: type,
        solid: true,
        icon,
      });
    },
  },
};
</script>

<style scoped></style>
